import { type ReactElement } from 'react';

export function FRMTerritoryInsights(): ReactElement {
  return <div />;
}
